import React from 'react'
import ContactForm from '../../components/Contact/ContactForm'
import WebBoosting1 from '../../components/WebBoosting/WebBoosting1'
import crmForm from "../../assets/img/services/crmForm.png"
import { Helmet } from 'react-helmet'
const WebsiteBoosting = () => {
  return (
    <>
      <Helmet>
        <title>Stackroots | Web Boosting</title>
      </Helmet>
      <div>
        <WebBoosting1 />
        <ContactForm title="Get a quote" image={crmForm} />
      </div>
    </>
  )
}

export default WebsiteBoosting